import { render, staticRenderFns } from "./increment-arrears.vue?vue&type=template&id=303b2fb6&scoped=true"
import script from "./increment-arrears.vue?vue&type=script&lang=js"
export * from "./increment-arrears.vue?vue&type=script&lang=js"
import style0 from "./increment-arrears.vue?vue&type=style&index=0&id=303b2fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b2fb6",
  null
  
)

export default component.exports